import styled from 'styled-components'
import { theme } from '@/client/components'
import font from '@/client/components/theme/font'
const { borders, color, space, breakpoint } = theme

export const Featured = styled.div`
  min-height: 300px;
  & .feat-breadcumb {
    & a,
    & span {
      font-weight: ${font.weight.normal};
    }
  }
  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 0};
  }
`

export const MainFeatured = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    padding-top: ${space.xl};
  }
`

export const LeftFeatured = styled.div`
  order: 2;
  width: 100%;

  @media (min-width: ${breakpoint.lg}) {
    width: 50%;
    order: 1;
    margin-right: 3%;
  }
`

export const Product = styled.div`
  order: 1;
  position: relative;
  width: calc(100% + ${space.xl3});
  margin-left: -${space.lg};
  margin-bottom: ${space.lg};

  @media (min-width: ${breakpoint.lg}) {
    order: 2;
    width: 40%;
    background-color: transparent;
  }

  @media (min-width: ${breakpoint.xl}) {
    width: 35%;
  }

  img {
    position: relative;
    z-index: 1;
    display: block;
    width: 100%;
    height: auto;

    @media (min-width: ${breakpoint.lg}) {
      border-radius: ${borders.radius.lg};
    }
  }
`

export const OutlinedSquare = styled.div`
  display: none;
  position: absolute;
  left: -8%;
  bottom: -${space.xl};
  width: 100%;
  height: 100%;
  border: ${borders.sizes.md} dashed ${color.grayscale.gray};
  border-radius: ${borders.radius.xl};

  @media (min-width: ${breakpoint.lg}) {
    display: block;
  }
`
export const BannerLeft = styled.div`
  padding-bottom: 3rem;
  max-width: 100%;
  & .banner-header-primary {
    line-height: 1.4;
    padding: 2rem 0 0 0;
  }

  & .banner-sub-primary {
    color: ${color.grayscale.greyalpha};
  }

  @media (min-width: ${breakpoint.hd}) {
    // max-width: 420px;
  }
`
export const LottieSet = styled.div`
  position: relative;
  max-width: 520px;

  & > div {
    position: relative;
    bottom: 0;
  }
  @media (min-width: ${breakpoint.hd}) {
    height: 280px;
    & > div {
      position: absolute;
      bottom: -150px;
    }
  }
`
